import { render } from "./CSectionTitle.vue?vue&type=template&id=4f8b7b60&scoped=true"
const script = {}

import "./CSectionTitle.vue?vue&type=style&index=0&id=4f8b7b60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8b7b60"]])

export default __exports__